import { render } from "./CxVerticalProperty.vue?vue&type=template&id=8c6a5e30"
import script from "./CxVerticalProperty.vue?vue&type=script&lang=js"
export * from "./CxVerticalProperty.vue?vue&type=script&lang=js"

import "./CxVerticalProperty.vue?vue&type=style&index=0&id=8c6a5e30&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__